import { css } from '@emotion/react';
import React from 'react';
import { useSelector } from 'react-redux';

import t from 'react-translate';
import { getCourseAliases } from 'redux/selectors/course';

import { danger, hexToRgbaString } from 'styles/global_defaults/colors';

interface NoAccessProps {
  postCourseCatalogId: string;
  courseName: string;
}
const styles = css`
  width: 780px;
  border: 1px dashed ${danger};
  background-color: ${hexToRgbaString(danger, 0.05)};
`;
const NoAccess: React.FC<NoAccessProps> = ({
  postCourseCatalogId: catalogId,
  courseName,
}) => {
  const aliases = useSelector(state => getCourseAliases(state));
  return (
    <div
      css={styles}
      className='d-flex align-items-center justify-content-center text-center p-2 mt-2 text-regular gray-1'
    >
      {t.COURSE_ANALYTICS.PRE_POST.NO_ACCESS({
        catalogId,
        courseName,
        ...aliases.learnersAliases,
      })}
    </div>
  );
};

export default NoAccess;
